import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Keep plain classes serializable when a wrapper is rendered on the server. */
export function withBaseClasses<State>(
  baseClasses: ClassValue,
  className: string | ((state: State) => string | undefined) | undefined,
): string | ((state: State) => string) {
  return typeof className === 'function' ? (state) => cn(baseClasses, className(state)) : cn(baseClasses, className);
}
